export const extractArgumentExternalRecordValue = (value) => {
  if (value?.type !== 'lexical') {
    return value;
  }

  const extractText = (node) => {
    if (!node) {
      return '';
    }

    if (node.text) {
      return node.text;
    }

    if (node.children) {
      return node.children.map((child) => extractText(child)).join('');
    }

    return '';
  };

  return extractText(value?.value?.root) || '';
};
